/**
 * @file All permissions checks related to updating checklist items
 */

import { MessageCreatorAndAssigned } from '../../../models/message';

import {
  CHECKLIST__ADMIN,
  CHECKLIST__CHECK,
  CHECKLIST__REORDER,
  CHECKLIST__UPDATE,
} from '../permissionsAll';

import { hasPermission } from './checklistHelper';

/**
 *
 * UPDATE
 *
 */

/**
 * Check whether the user has permission
 * to mark a checklist item as checked
 * for a new message
 *
 * @returns Whether the user has permission
 */
export const getCanSetStateForNewMessage = (): boolean => {
  // If the user can create a message, they can also check checklist items
  return true;
};

/**
 * Check whether the user has permission
 * to mark a checklist item as checked
 * for an existing message
 *
 * @param message The message to check the permission for
 * @returns       Whether the user has permission
 */
export const getCanSetStateForExistingMessage = (
  message: MessageCreatorAndAssigned,
): boolean => {
  if (message.isArchived) {
    return false;
  }

  return hasPermission(CHECKLIST__CHECK) || hasPermission(CHECKLIST__ADMIN);
};

/**
 * Check whether the user has permission
 * to mark a checklist item as checked
 * for a new message
 *
 * @returns Whether the user has permission
 */
export const getCanSetTextForNewMessage = (): boolean => {
  // If the user can create a message, they can also check checklist items
  return true;
};

/**
 * Check whether the user has permission
 * to mark a checklist item as checked
 * for an existing message
 *
 * @param message The message to check the permission for
 * @returns       Whether the user has permission
 */
export const getCanSetTextForExistingMessage = (
  message: MessageCreatorAndAssigned,
): boolean => {
  if (message.isArchived) {
    return false;
  }

  return hasPermission(CHECKLIST__UPDATE) || hasPermission(CHECKLIST__ADMIN);
};

/**
 * Check whether the user has permission
 * to reorder checklist items for a new message
 *
 * @returns Whether the user has permissions
 */
export const getCanReorderItemForNewMessage = (): boolean => {
  // If the user can create a message, they can also reorder checklist items
  return true;
};

/**
 * Check whether the user has permission
 * to reorder checklist items for an existing message
 *
 * @param message The message to check the permission for
 * @returns       Whether the user has permissions
 */
export const getCanReorderItemForExistingMessage = (
  message: MessageCreatorAndAssigned,
): boolean => {
  if (message.isArchived) {
    return false;
  }

  return hasPermission(CHECKLIST__REORDER) || hasPermission(CHECKLIST__ADMIN);
};
